module.exports = __webpack_public_path__ + "img/zgh.469034e1.jpg";